import { useRef, useState } from 'react';
import styled from 'styled-components';
import LOGO from '../../assets/Logo.png';
import { Link } from 'react-router-dom';
import { ChevronsDown } from 'lucide-react';
import { FaApple, FaAndroid } from 'react-icons/fa';
import HeroVideo from '../../assets/herovideo.mp4';
import GetStartedModal from '../NewHero/GetStartedModal';

const AppContainer = styled.div`
    height: auto;
    color: white;
    font-family: Very Sans, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    position: relative;
    overflow-x: hidden;
`;

const Header = styled.header`
    padding-top: 1rem;
    backdrop-filter: blur(10px);
    position: sticky;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    top: 0;
    z-index: 100;
    margin: 0 auto;
    max-width: 80%;
    @media screen and (max-width: 756px) {
    display: none;
    
    }
`;

const Nav = styled.nav`
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;

const LogoIcon = styled.img`
    width: 50px;
    height: 50px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const NavLinks = styled.div`
    display: flex;
    gap: 0.5rem;
    
    @media (max-width: 768px) {
        display: none;
    }
`;

const NavLink = styled(Link)`
    color: rgba(255, 255, 255, 0.6);
    text-decoration: none;
    background-color: rgba(255, 255, 255, 0.025);
    font-weight: 400;
    font-size: 14px;
    padding: 5px 12.5px;
    border-radius: 5px;
    font-family: Very Sans, Sans Serif;
    transition: color 0.3s ease;
    
    &:hover {
        background-color: rgba(59, 130, 246, 0.3);
    }
`;

const NavButton = styled.button`
    color: rgba(255, 255, 255, 0.6);
    background-color: rgba(255, 255, 255, 0.025);
    border: none;
    font-weight: 400;
    font-size: 14px;
    padding: 5px 12.5px;
    border-radius: 5px;
    font-family: Very Sans, Sans Serif;
    transition: color 0.3s ease;
    cursor: pointer;
    
    &:hover {
        background-color: rgba(59, 130, 246, 0.3);
    }
`;

const NavLinkWrapper = styled.div`
    position: relative;
`;

const NavLinkA = styled.div`
    color: rgba(255, 255, 255, 0.6);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.025);
    font-weight: 400;
    font-size: 14px;
    padding: 5px 12.5px;
    border-radius: 5px;
    font-family: Very Sans, Sans Serif;
    transition: all 0.3s ease;
    gap: 5px;
    cursor: pointer;
    
    &:hover {
        background-color: rgba(59, 130, 246, 0.3);
    }
    
    svg {
        transform: ${props => props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
        transition: transform 0.3s ease;
    }
`;

const DropdownMenu = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 0.5rem;
    background: rgba(2, 6, 17, 0.98);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 0.5rem;
    min-width: 180px;
    opacity: ${props => props.$isOpen ? 1 : 0};
    visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
    transform: ${props => props.$isOpen ? 'translateY(0)' : 'translateY(-10px)'};
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(10px);
    z-index: 1000;
`;

const DropdownItem = styled.a`
    color: rgba(255, 255, 255, 0.6);
    text-decoration: none;
    padding: 10px 12px;
    border-radius: 5px;
    font-size: 14px;
    font-family: Very Sans, Sans Serif;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    
    &:hover {
        background-color: rgba(59, 130, 246, 0.3);
        color: rgba(255, 255, 255, 1);
    }
    
    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        
        &:hover {
            background-color: transparent;
            color: rgba(255, 255, 255, 0.6);
        }
    }
`;

const Button = styled.button`
    background: #3B82F6;
    color: white;
    border: none;
    padding: 10px 17.5px;
    border-radius: 5px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.3s ease;
    font-family: Very Sans, Sans Serif;
    
    &:hover {
        background: #2563EB;
    }
`;

const HeroDiv = styled.div`
    position: relative;
    margin: 1rem auto;
    width: 80%;
    height: 40vh;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 756px) {
        width: 100%;
        height: 100vh;
        border-radius: 0px;
        margin: 0 auto;
    }
`;

const VideoBackground = styled.video`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
`;

const VideoOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.3) 0%,
        rgba(0, 0, 0, 0.5) 100%
    );
    z-index: 1;
    
    @media screen and (max-width: 756px) {
        background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.4) 0%,
            rgba(0, 0, 0, 0.7) 100%
        );
    }
`;

const HeroDivInner = styled.div`
    position: relative;
    z-index: 2;
    width: 80%;
    height: 80%;
    padding: 20px;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    
    @media screen and (max-width: 756px) {
        width: 90%;
        height: auto;
        align-items: center;
        justify-content: center;
        text-align: center;
        gap: 2rem;
        padding: 2rem 1rem;
    }
`;

const HeroTitle = styled.h1`
    font-family: Very Sans Headline, Sans Serif;
    font-weight: 600;
    color: #ffffff;
    font-size: 46px;
    margin: 0;
    line-height: 1.2;
    
    @media screen and (max-width: 756px) {
        font-size: 48px;
        margin-bottom: 1rem;
        text-shadow: 0 2px 20px rgba(0, 0, 0, 0.5);
    }
    
    @media screen and (max-width: 480px) {
        font-size: 40px;
    }

    .highlight {
        background: linear-gradient(135deg, #3B82F6 0%, #a78bfa 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }
`;

const HeroSubtitle = styled.p`
    display: none;
    
    @media screen and (max-width: 756px) {
        display: block;
        font-family: Very Sans, Sans Serif;
        font-size: 18px;
        color: rgba(255, 255, 255, 0.9);
        line-height: 1.5;
        margin: 0 0 2rem 0;
        max-width: 500px;
    }
    
    @media screen and (max-width: 480px) {
        font-size: 16px;
    }
`;

const MobileButtonGroup = styled.div`
    display: none;
    
    @media screen and (max-width: 756px) {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        width: 100%;
        max-width: 400px;
    }
`;

const MobileButton = styled.button`
    display: none;
    
    @media screen and (max-width: 756px) {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.75rem;
        background: ${props => props.$primary ? '#3B82F6' : 'rgba(255, 255, 255, 0.1)'};
        backdrop-filter: blur(10px);
        color: white;
        border: ${props => props.$primary ? 'none' : '1px solid rgba(255, 255, 255, 0.2)'};
        padding: 16px 24px;
        border-radius: 12px;
        font-weight: 600;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.3s ease;
        font-family: Very Sans, Sans Serif;
        
        &:hover {
            background: ${props => props.$primary ? '#2563EB' : 'rgba(255, 255, 255, 0.15)'};
            transform: translateY(-2px);
        }
        
        &:active {
            transform: translateY(0);
        }
    }
`;

const MobileLogo = styled.div`
    display: none;
    
    @media screen and (max-width: 756px) {
        display: flex;
        position: absolute;
        top: 2rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
        
        img {
            width: 60px;
            height: 60px;
            border-radius: 12px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        }
    }
`;

const NewHero = ({ communityRef, hydrixNodeRef }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const scrollToCommunity = () => {
        communityRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToNode = () => {
        hydrixNodeRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const openExplorer = () => {
        window.open(
            'https://www.hydrix.online',
            '_blank',
            'noopener,noreferrer'
        );
    };

    const handleGetStarted = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleAndroidDownload = () => {
        window.open(
            "https://play.google.com/store/apps/details?id=com.HydrixApp",
            "_blank",
            "noopener,noreferrer"
        );
        setIsDropdownOpen(false);
    };

    const handleDownloadios = () => {
        window.open(
        "https://apps.apple.com/app/id6753764380",
        "_blank",
        'noopener, noreferrer'
        );
        setIsDropdownOpen(false);
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    return (
        <AppContainer>
            <Header>
                <Nav>
                    <LogoIcon src={LOGO} />
                    <NavLinks>
                        <NavLink>Docs</NavLink>
                        <NavButton onClick={scrollToCommunity}>Community</NavButton>
                        
                        <NavLinkWrapper onMouseLeave={() => setIsDropdownOpen(false)}> 
                            <NavLinkA onClick={toggleDropdown} $isOpen={isDropdownOpen}>
                                Mine
                                <ChevronsDown size={14} color='#94A3B8' />
                            </NavLinkA>
                            <DropdownMenu $isOpen={isDropdownOpen}>
                                <DropdownItem onClick={handleAndroidDownload}>
                                    <FaAndroid size={18} />
                                    Android App
                                </DropdownItem>
                                <DropdownItem onClick={handleDownloadios}>
                                    <FaApple size={18} />
                                    iOS App 
                                </DropdownItem>
                            </DropdownMenu>
                        </NavLinkWrapper>
                        
                        <NavButton onClick={openExplorer}>Explorer</NavButton>
                        <NavButton onClick={scrollToNode}>Nodes</NavButton>
                        <NavLink to="/hydrixpay">Pay</NavLink>
                    </NavLinks>
                </Nav>
                <Button onClick={handleGetStarted}>Get Started</Button>
            </Header>
            
            <HeroDiv>
                <VideoBackground 
                    src={HeroVideo}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onMouseEnter={(e) => e.target.pause()}
                    onMouseLeave={(e) => e.target.play()}
                />
                <VideoOverlay />
                <MobileLogo>
                    <img src={LOGO} alt="Hydrix" />
                </MobileLogo>
                <HeroDivInner>
                    <HeroTitle>
                        <span className="highlight">Mine</span>, Explore, Create
                    </HeroTitle>
                    <HeroSubtitle>
                        Join the future of cryptocurrency mining. Start earning from day one with Hydrix's proven infrastructure.
                    </HeroSubtitle>
                    <MobileButtonGroup>
                        <MobileButton $primary onClick={handleGetStarted}>
                            Get Started
                        </MobileButton>
                        <MobileButton onClick={handleAndroidDownload}>
                            <FaAndroid size={20} />
                            Download for Android
                        </MobileButton>
                        <MobileButton onClick={handleDownloadios}>
                            <FaApple size={20} />
                            Download for iOS
                        </MobileButton>
                    </MobileButtonGroup>
                </HeroDivInner>
            </HeroDiv>
            
            <GetStartedModal 
                isOpen={isModalOpen} 
                onClose={handleCloseModal} 
            />
        </AppContainer>
    );
};

export default NewHero;